// flow

import { FAQEditor } from "./faq-editor";
export default FAQEditor;